import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import style from './style.module.scss';

interface Props<T extends string> extends ClassNameProp {
  title?: string;
  tabs: T[];
  selectedTab: T | null;
  selectTab: (tab: T) => void;
  compact?: boolean;
  translationKey?: string;
}

const Tabs = <T extends string>({
  title,
  tabs,
  selectedTab,
  selectTab,
  compact = false,
  translationKey,
  className
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <>
      {title && <div className={style.tabsTitle}>{title}</div>}
      <ul className={classNames(style.tabs, className)}>
        {tabs.map(tab => (
          <li key={tab}>
            <button
              className={classNames(style.tabButton, {
                [style.selected]: selectedTab === tab,
                [style.compact]: compact
              })}
              type="button"
              onClick={() => selectTab(tab)}
            >
              {translationKey ? t(`${translationKey}-${tab}`) : tab}
            </button>
          </li>
        ))}
      </ul>
    </>
  );
};

Tabs.displayName = 'Tabs';

export default Tabs;
